export const {
  PUBLIC_URL,
  REACT_APP_ACCESS_TOKEN_NAME,
  REACT_APP_API_BASE_URL,
  REACT_APP_API_PRINCIPAL_URL,
  REACT_APP_BASE_SURVEY_URL,
  REACT_APP_BASE_URL,
  REACT_APP_CAPTCHA_ENABLED,
  REACT_APP_CAPTCHA_SITE_KEY,
  REACT_APP_CAPTCHA_THRESHOLD_SCORE,
  REACT_APP_CUSTOMER_SUCCESS_BASE_URL,
  REACT_APP_ENVIRONMENT,
  REACT_APP_FEATURE_FLAG_ADD_PARTICIPANT_LINK,
  REACT_APP_FEATURE_FLAG_AUTOMATIC_CANCELLATION,
  REACT_APP_FEATURE_FLAG_CASES_TCP,
  REACT_APP_FEATURE_FLAG_DECLARATION_INADMISSIBILITY,
  REACT_APP_FEATURE_FLAG_DOWNLOAD_LINK_EXCEL_RESULT,
  REACT_APP_FEATURE_FLAG_HABILITY_STATUS,
  REACT_APP_FEATURE_FLAG_HABILITY_V3,
  REACT_APP_FEATURE_FLAG_NOTIFICATION_PROVIDER,
  REACT_APP_FEATURE_FLAG_ORGANIZATION_SELECT,
  REACT_APP_FEATURE_FLAG_PARTICIPANT_LINK,
  REACT_APP_FEATURE_FLAG_REGIONS_TAG,
  REACT_APP_FEATURE_FLAG_SERVICES_ATTACH,
  REACT_APP_FEATURE_FLAG_SERVICES_EXCEL,
  REACT_APP_FEATURE_FLAG_SERVICES_MAX_DATE,
  REACT_APP_FEATURE_FLAG_SERVICES_SEARCH,
  REACT_APP_FEATURE_FLAG_QUOTE_BID_SIZE_PAGINATION,
  REACT_APP_GOOGLE_ANALYTICS_KEY,
  REACT_APP_GOOGLE_ANALYTICS_SNIPPET_VERSION,
  REACT_APP_GOOGLE_TASK_MANAGER_KEY,
  REACT_APP_HOTJAR_ID,
  REACT_APP_HOTJAR_SNIPPET_VERSION,
  REACT_APP_MERCADO_PUBLICO_BASE_URL,
  REACT_APP_PARTICIPANT_LIST_URL,
  REACT_APP_PROVIDERS_BASE_URL,
  REACT_APP_SELLER_BASE_URL,
  REACT_APP_TCP,
  REACT_APP_FEATURE_FLAG_ENABLE_SURVEY,
  REACT_APP_SHOW_INABILITIES_V2,
  REACT_APP_FEATURE_FLAG_BUYER_ATTACHMENTS_RESTRICTED_TO_SAVED_STATE
} = process.env
export const isDevEnv = process.env.REACT_APP_ENVIRONMENT !== 'prod'
export const isLocalEnv = process.env.REACT_APP_ENVIRONMENT === 'local'
